import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';

import { columns } from './columns';
import { PassengerAddressEmptyState } from './PassengerAddressEmptyState';
import { DataGrid } from 'src/common/DataGrid/DataGrid';
import type { PassengerAddressRead } from 'src/common/external/bambi-api/bambiApi';
import { useLocationsPassengerAddressesListQuery } from 'src/common/external/bambi-api/bambiApi';

interface PassengerAddressDataGridProps {
  passengerId?: string;
}

export function PassengerAddressDataGrid({
  passengerId,
}: PassengerAddressDataGridProps) {
  const { data: passengerAddresses, isLoading } =
    useLocationsPassengerAddressesListQuery(
      { search: passengerId ?? '', ordering: '-last_used_at' },
      { skip: !passengerId }
    );

  return (
    <>
      {isLoading ? (
        <div className="my-72 flex justify-center">
          <LoadingIndicator />
        </div>
      ) : (
        <DataGrid<PassengerAddressRead>
          tableId="passenger-address"
          dataTestId="passenger-address-table"
          containerClassName="max-h-[220px]"
          columns={columns}
          data={passengerAddresses?.results ?? []}
          emptyState={<PassengerAddressEmptyState />}
          getRowId={(row) => row.id}
          totalCount={passengerAddresses?.count ?? 0}
          includePagination={false}
        />
      )}
    </>
  );
}
